import * as React from "react";
import {
  BoolConfig,
  ColumnConfig,
  DateConfig,
  EnumConfig,
  RangeConfig,
  StringConfig
} from "./columnConfig";

export type Filter = {
  show: boolean;
  value: any;
};

export type Actions = {
  width: number;
  render: React.ComponentType<{ row: any }>;
};

export type Config = (
  | BoolConfig
  | DateConfig
  | EnumConfig
  | RangeConfig
  | StringConfig) &
  ColumnConfig;

export type ContextType = {
  columnConfig: Config[];
  columnConfigAll: Config[];
  data: any[];
  rowColor1: string;
  rowColor2: string;
  t: any;
  toggleSort: (key: string) => void;
  sortKey: string | null;
  sortDirection: "asc" | "desc";
  getFilter: (key: string) => Filter;
  setFilterShow: (key: string, show: boolean) => void;
  setFilterValue: (key: string, value: any) => void;
  setFilters: (filterMap: Record<string, any>) => void;
  setShowColumn: (key: string, value: boolean) => void;
  showMap: Record<string, boolean>;
  hasBulkSelect: boolean;
  selectedRows?: string[];
  onSelectedRowsChange?: (rows: string[]) => void;
  actions?: Actions;
  onRowClick?: (row: any) => void;
  hoveredRowIndex: number | null;
  setHoveredRowIndex: (index: number | null) => void;
  isLoading: boolean;
};

const Context = React.createContext({} as ContextType);

export default Context;
